import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, FieldLabel, TextField, ValidationIcon } from 't3-widgets'

import { VALIDATORS_CONFIG } from '../../../../../../common/constants'
import { getTooltip, getValidator } from '../../../common/operations'

import styles from '../pages.module.css'

const SerialNumberField = ({
    intl,
    isDakDevice,
    onSerialChange,
    serial,
    serialCorrectness,
    serverVerified,
    verifyDataOnServer
}) => {
    const [serialError, setSerialError] = useState(false)

    const conf = VALIDATORS_CONFIG.step2

    const setSerialNumberError = () => {
        const error = new Error(intl.translate('ap_error_regex'))

        setSerialError(serialCorrectness ? false : error)
    }

    return (
        <div className={styles['input-field']}>
            <FieldLabel
                id="serial-number-label"
                label={intl.translate('ap_step2_deviceserial_label')}
                tooltip={getTooltip(
                    intl.translate('ap_step2_deviceserial_label'),
                    intl.translate('ap_step2_deviceserial_label_hint')
                )}
            >
                <div className={styles['validated-input-container']}>
                    <div className={styles['validated-input-field']}>
                        <TextField
                            id="serial-number-text-field"
                            onBlur={() => getValidator(conf.serialNo.enabled.correctness, setSerialNumberError(), null)}
                            value={serial}
                            onChange={onSerialChange}
                            onFocus={() => setSerialError(false)}
                            type={isDakDevice || (!isDakDevice && !serverVerified) ? 'text' : 'password'}
                            error={serialError}
                            placeholder={intl.translate('wf_reporting_required')}
                            readOnly={serverVerified}
                        />
                    </div>
                    <div className={styles['validated-input-checker']}>
                        <div className={styles['vertical-align-container']}>
                            <div className={styles['vertical-align-item']}>
                                {serverVerified ? (
                                    <ValidationIcon
                                        className={styles['success-server-verified']}
                                        width={25}
                                        inheritColor
                                    />
                                ) : (
                                    <Button
                                        id="verify-device-button"
                                        disabled={!serialCorrectness}
                                        onClick={verifyDataOnServer}
                                        primary={serialCorrectness}
                                    >
                                        {intl.translate('btn_verify')}
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </FieldLabel>
        </div>
    )
}

SerialNumberField.propTypes = {
    intl: PropTypes.objectOf(PropTypes.func),
    isDakDevice: PropTypes.boolean,
    onSerialChange: PropTypes.func,
    serial: PropTypes.string,
    serialCorrectness: PropTypes.boolean,
    serverVerified: PropTypes.boolean,
    verifyDataOnServer: PropTypes.func
}

export { SerialNumberField }
